export const equipmentDomestic = [
  {
    name: 'equipment_domestic_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
